// Shared UI atoms for the Intelligence Commerciale module.
// Keeps the page components lean and consistent.
import { Shield, ShieldAlert, ShieldCheck, ShieldOff } from "lucide-react";

export const COMPLIANCE_META = {
  allowed:          { label: "Contact autorisé",  Icon: ShieldCheck, cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  consent_required: { label: "Consentement requis", Icon: ShieldAlert, cls: "bg-amber-50 text-amber-800 border-amber-200" },
  do_not_contact:   { label: "Ne pas contacter", Icon: ShieldOff,   cls: "bg-rose-50 text-rose-700 border-rose-200" },
  to_verify:        { label: "À vérifier",       Icon: Shield,      cls: "bg-slate-50 text-slate-700 border-slate-200" },
};

export function ComplianceBadge({ status, className = "" }) {
  const meta = COMPLIANCE_META[status] || COMPLIANCE_META.to_verify;
  const Icon = meta.Icon;
  return (
    <span
      data-testid={`compliance-badge-${status || "unknown"}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[10px] font-mono uppercase tracking-widest border ${meta.cls} ${className}`}
    >
      <Icon className="h-3 w-3" strokeWidth={1.8} />
      {meta.label}
    </span>
  );
}

export function ScorePill({ label, value, tone = "navy" }) {
  const bg = {
    navy: "bg-[#0B2545] text-white",
    gold: "bg-[#DCC29A] text-[#0B2545]",
    ghost: "bg-[#F2EFE7] text-[#0B2545]",
  }[tone];
  return (
    <div className="flex flex-col items-start">
      <div className="text-[9px] font-mono uppercase tracking-[0.2em] text-[#8B8B8F]">{label}</div>
      <div className={`mt-1 inline-flex items-baseline gap-1 rounded-md px-2.5 py-1 ${bg}`}>
        <span className="text-lg font-semibold leading-none">{value ?? "—"}</span>
        {value != null && <span className="text-[10px] opacity-70">/100</span>}
      </div>
    </div>
  );
}

export function StatCard({ label, value, hint, testId }) {
  return (
    <div className="rounded-md border border-[#E4E1D8] bg-white px-5 py-4" data-testid={testId}>
      <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#8B8B8F]">{label}</div>
      <div className="mt-1 text-2xl font-semibold text-[#0B2545]">{value ?? "—"}</div>
      {hint && <div className="mt-1 text-[11px] text-[#5B5B62]">{hint}</div>}
    </div>
  );
}

export function SectionTitle({ children, sub }) {
  return (
    <div className="mb-4">
      <h2 className="text-base font-medium text-[#0B2545]">{children}</h2>
      {sub && <p className="mt-0.5 text-xs text-[#5B5B62]">{sub}</p>}
    </div>
  );
}
